// extracted by mini-css-extract-plugin
export default {"detail_service":"style_detail_service__2ppVF","headline":"style_headline__k8lQ4","text_container":"style_text_container__mpYMk"};